export default __webpack_public_path__ + "static/media/submit-quote-grap.000a3cce.svg";